import { create } from 'zustand';

type State = {
  translationsLoading: boolean;
  isTranslating: boolean;
  translatingProjects: [] | { projectId: string | undefined; language: string; length: number }[];
};

type Action = {
  setTranslationsLoading: (category: boolean) => void;
  setTranslating: (category: boolean) => void;
  setTranslatingProjects: (
    category: [] | { projectId: string | undefined; language: string; length: number }[],
  ) => void;
};

const useTranslationsLoadingStore = create<State & Action>((set) => ({
  translationsLoading: false,
  setTranslationsLoading: (loading) => set({ translationsLoading: loading }),
  isTranslating: false,
  setTranslating: (loading) => set({ isTranslating: loading }),
  translatingProjects: [],
  setTranslatingProjects: (projects) => set({ translatingProjects: projects }),
}));

export default useTranslationsLoadingStore;
